import React from 'react'
import Banner from './Banner'
import AerobottOverview from './AerobottOverview'
import SimplicityFAQ from './SimplicityFAQ'
import DemoForm from '../DemoFrom'
const AeroAgriMain = () => {
  return (
    <div>
    <Banner />
      <AerobottOverview />
      <SimplicityFAQ />
      <DemoForm />
    </div>
  )
}

export default AeroAgriMain;